module.exports = __webpack_public_path__ + "static/media/1.b6b4d950.jpg";